module.exports = __webpack_public_path__ + "6adcbfdb155c3bbd89f4b3e9413639eb.png";